// extracted by mini-css-extract-plugin
export default {"header":"hero-header-module--header--13j1S","wave":"hero-header-module--wave--3Q9DN","shapeBackground":"hero-header-module--shapeBackground--3OBCY"};